import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import * as models from '../../models';

export interface IAccountOwnerService {
  getAccountOwnerList(request: GetAccountOwnerListRequest): Observable<GetAccountOwnerListResponse>;
}

export const SERVICE_TOKEN = new InjectionToken('Shared.IAccountOwnerService');

export class GetAccountOwnerListRequest {
  skip = 0;
  limit = 200;
  name?: string;
}

export class GetAccountOwnerListResponse {
  entities: Array<models.AccountOwner> = [];
}
